import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";
import disableElement from "../../functions/disableElement";
import enableElement from "../../functions/enableElement";

export default class extends Controller {
  static get targets() {
    return [
      "dateFieldContainer",
      "customDateContainer",
      "fixedSwitch",
      "customDateSwitch",
      "dateField",
      "expirySwitch",
      "expiryDateFieldContainer",
      "expiryDateField"
    ];
  }

  connect() {
    this.checkDateVisibility();
    this.checkExpiryVisibility();
  }

  checkDateVisibility() {
    if (!this.hasFixedSwitchTarget) {
      return;
    }

    if (this.fixedSwitchTarget.checked) {
      showElement(this.customDateContainerTarget, this.customDateContainerDisplay);

      if (this.customDateSwitchTarget.checked) {
        showElement(this.dateFieldContainerTarget, this.dateFieldContainerDisplay);
        enableElement(this.dateFieldTarget);
      } else {
        hideElement(this.dateFieldContainerTarget);
        disableElement(this.dateFieldTarget);
      }
    } else {
      this.customDateContainerDisplay = hideElement(this.customDateContainerTarget);
      this.dateFieldContainerDisplay = hideElement(this.dateFieldContainerTarget);
      disableElement(this.dateFieldTarget);
    }
  }

  checkExpiryVisibility() {
    if (!this.hasExpirySwitchTarget) {
      return;
    }

    if (this.expirySwitchTarget.checked) {
      showElement(this.expiryDateFieldContainerTarget);
      enableElement(this.expiryDateFieldTarget);
    } else {
      hideElement(this.expiryDateFieldContainerTarget);
      disableElement(this.expiryDateFieldTarget);
    }
  }
}
